import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

const messages = defineMessages({
  unauthorized: {
    id: 'home.welcome',
    defaultMessage: 'We are sorry but you do not have the privilege/right to access this page, ' +
    'please contact your portal administrator.',
    description: 'A message to display when user does not have the right user role assigned.'
  }
});

class Unauthorized extends Component {
  static propTypes = {
    customMessage: PropTypes.string
  };

  render() {
    return <section className='flex-container flex-justify-center flex-align-center'>
      <h1>
        <FormattedMessage { ...messages.unauthorized } />
      </h1>
    </section>;
  }
}

export default Unauthorized;



// WEBPACK FOOTER //
// ./src/pages/Unauthorized.js